var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2886 6.64134L1.85276 6.21665C1.66822 6.03682 1.66822 5.74603 1.85276 5.56812L5.6673 1.84915C5.85185 1.66932 6.15026 1.66932 6.33284 1.84915L10.1474 5.56621C10.3319 5.74604 10.3319 6.03682 10.1474 6.21473L9.71154 6.63943C9.52504 6.82117 9.22074 6.81734 9.03816 6.63178L6.78634 4.32846L6.78634 9.82657C6.78634 10.081 6.57628 10.2857 6.31517 10.2857H5.68694C5.42583 10.2857 5.21576 10.081 5.21576 9.82657L5.21576 4.32846L2.96198 6.63369C2.7794 6.82117 2.4751 6.825 2.2886 6.64134Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendArrowUp);
export default __webpack_public_path__ + "97120/static/media/TrendArrowUp.39a098daa5d33f6221cfbf8e794b8b4d.svg";
export { ForwardRef as ReactComponent };